import { render, staticRenderFns } from "./plat-form-select.vue?vue&type=template&id=8b90771a&"
import script from "./plat-form-select.vue?vue&type=script&lang=js&"
export * from "./plat-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports